/* eslint-disable */
export const debounce = function (func: () => void, wait = 50) {
	let h: any;
	return () => {
		clearTimeout(h);
		h = setTimeout(() => func(), wait);
	};
};
/* eslint-enable */

export const isANumber = function (field: string | null): boolean {
	if (field !== null && !isNaN(Number(field))) {
		return true;
	}
	return false;
};
